<my-content placeholder="navigation">

    <div class="col-sm-12" style="border-bottom: 1px solid #ccc;"></div>
    <div class="col-sm-12">&nbsp;</div>

    <div class="col-sm-12">

        <span style="font-size: 16px; color:#494949;"><b>Import {{ImportType}}</b></span>
        <hr><br/>
        <table class="LMtable" style="min-width:40%;">
            <tr *ngIf="CurrentStep== 1">
                <th>
                    <div class="col-sm-8">Step 1 : Upload File</div>
                    <div class="col-sm-4"><a href={{TargetFile}} target="_blank">Download Sample File</a></div>
                </th>
            </tr>
            <tr *ngIf="CurrentStep== 1">
                <td>
                    <div class="col-sm-12">
                        <input type='file' accept=".xlsx" (change)="onSelectFile($event)">
                        <br/>
                        <!-- <input class="btn btn-primary btn-sm" type="submit" (click)="onSubmit()" value="Upload File"> -->
                        <button class="btn  btn-primary btn-sm" type="submit" (click)="onSubmit()">
                        Upload File&nbsp;<span *ngIf="loading" class="spinner-border spinner-border" role="status" aria-hidden="true"></span>
                    </button>
                    </div>
                </td>
            </tr>
            <tr *ngIf="CurrentStep== 1 && Status != 200">
                <td><span class="Err">{{Msg}}</span></td>
            </tr>


            <tr *ngIf="CurrentStep ==2">
                <th>Step 2 : Column Mapping</th>
            </tr>
            <tr *ngIf="CurrentStep ==2">
                <td>
                    <form [formGroup]="form" role="form">
                        <div class="col-sm-12" style="height:400px; width:700px; overflow-y:scroll;">
                            <table width="100%" class="LMtable">
                                <tr>
                                    <th>S.No.</th>
                                    <th>Column</th>
                                    <th>Description</th>
                                    <th>Map Column</th>
                                </tr>
                                <tr *ngFor="let row of formData; let i=index ">
                                    <td align="center">{{i+1}}
                                        <!-- <input class="form-control" [formControlName]="row.Field" type="hidden" [value]="row.Field" /> -->
                                    </td>
                                    <td> {{row.Caption}} </td>
                                    <td> {{row.Description}} </td>
                                    <td>
                                        <select class="form-control" [formControlName]="row.Field" [name]="row.Caption" [id]="row.Caption" [value]="row.Caption">
                                    <option value="0">Not Selected</option>
                                    <option *ngFor="let option of ModuleData" [value]="option.Caption">{{option.Caption}}</option>
                                </select>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-sm-12">&nbsp;</div>
                        <div class="col-sm-12">
                            <!-- <input class="btn btn-primary btn-sm" type="submit" (click)="SaveMapping()" value="Map & Process"> -->
                            <button class="btn  btn-primary btn-sm" type="submit" (click)="SaveMapping()">
                            Map & Process&nbsp;<span *ngIf="loading" class="spinner-border spinner-border" role="status" aria-hidden="true"></span>
                        </button>
                        </div>
                    </form>

                </td>
            </tr>
            <tr *ngIf="CurrentStep== 2 && Status != 200">
                <td><span class="Err">{{Msg}}</span></td>
            </tr>


            <tr *ngIf="CurrentStep ==3">
                <th>Status</th>
            </tr>
            <tr *ngIf="CurrentStep ==3">
                <td>
                    <span class="Err"><b>{{Msg}}</b></span>
                    <br/>
                    <a href={{DownloadURL}}{{DownloadFilePath}}>Download Log File</a>
                </td>
            </tr>
        </table>
    </div>
    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>

    </div>
    <div class="jumbotron p-4">
        <div class="container text-center col-sm-3 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div>
</my-content>
<my-content placeholder="main">

</my-content>